// This file added by Bearer Web Developer
const subtractEighteenYears = () => {
    const date = new Date();
    const year = String(date.getFullYear() - 18);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export default subtractEighteenYears;